export default "__VITE_ASSET__gPq0f$me__"